/* eslint-disable no-console */
/* eslint-disable react/jsx-filename-extension */
/* eslint-disable react/react-in-jsx-scope */
/* eslint-disable no-shadow */
import { useState } from 'react';
// @mui
import {
  Stack,
  Typography,
  Divider,
  Box,
  Container,
  Grid,
  Card,
} from '@mui/material';
import { Helmet } from 'react-helmet-async';
// components
import { useSelector } from 'react-redux';
import { useSnackbar } from 'notistack';
import Alert from '@mui/material/Alert';
import axiosInstance from '../utils/axiosInstance';
import CameraInfo from '../components/camera-info/cameraInfo';
import CameraNetworkInfo from '../components/camera-network-info/cameraNetworkInfo';
import SingleSelector from '../components/single-selector/singleSelector';

export default function CameraDetails() {
  const { adaptorType } = window;
  const { enqueueSnackbar } = useSnackbar();
  const [camera, setCamera] = useState(null);
  const [cameraInfo, setCameraInfo] = useState(null);
  const [cameraNetwork, setCameraNetwork] = useState(null);
  const [infoFetchStatus, setInfoFetchStatus] = useState('uninitialized');
  const [networkFetchStatus, setNetoworkFetchStatus] = useState('uninitialized');
  const cameraList = useSelector((state) => state.app.cameraList);

  const fetchCameraDetails = (camera) => {
    if (!camera) {
      return;
    }
    setInfoFetchStatus('pending');
    axiosInstance
      .get(
        `${window.location.protocol}//${camera.host}/api/v1/sensor/${camera.sensorId}/info`,
      )
      .then(async (response) => {
        setInfoFetchStatus('success');
        console.debug('fetchInfo response: ', response.data);
        setCameraInfo(response.data);
      })
      .catch((error) => {
        setInfoFetchStatus('error');
        if (error.response.data == null) {
          enqueueSnackbar(`Error - ${error.response.status}`, {
            variant: 'error',
            anchorOrigin: { horizontal: 'right', vertical: 'bottom' },
          });
        } else {
          enqueueSnackbar(`Error - ${error.response.data.error_message}`, {
            variant: 'error',
            anchorOrigin: { horizontal: 'right', vertical: 'bottom' },
          });
        }
      });

    if (adaptorType !== 'mms') {
      setNetoworkFetchStatus('pending');
      axiosInstance
        .get(
          `${window.location.protocol}//${camera.host}/api/v1/sensor/${camera.sensorId}/network`,
        )
        .then(async (response) => {
          setNetoworkFetchStatus('success');
          console.debug('fetchNetwork response: ', response.data);
          setCameraNetwork(response.data);
        })
        .catch((error) => {
          setNetoworkFetchStatus('error');
          if (error.response.data == null) {
            enqueueSnackbar(`Error - ${error.response.status}`, {
              variant: 'error',
              anchorOrigin: { horizontal: 'right', vertical: 'bottom' },
            });
          } else {
            enqueueSnackbar(`Error - ${error.response.data.error_message}`, {
              variant: 'error',
              anchorOrigin: { horizontal: 'right', vertical: 'bottom' },
            });
          }
        });
    }
  };

  const handleCameraSelect = (cam) => {
    setCamera(cam);
    fetchCameraDetails(cam);
    if (!cam) {
      setCameraInfo(null);
      if (adaptorType !== 'mms') {
        setCameraNetwork(null);
      }
    }
  };

  // Function to filter authorized cameras
  const filterAuthorized = (cameraList) => cameraList
    .filter((camera) => camera.isAuthorized === true);

  const cameraInfoPresent = camera != null && cameraInfo != null;
  const networkInfoPresent = camera != null && cameraNetwork != null;

  return (
    <>
      <Helmet>
        <title> Camera details </title>
      </Helmet>

      <Container maxWidth="xl">
        <Typography variant="h4" sx={{ mb: 5 }}>
          Camera Info and network details
        </Typography>
        <Grid container spacing={3}>
          <Grid item xs={12} sm={12} md={12}>
            <Card>
              <Box sx={{ p: 3 }}>
                <Stack spacing={3} sx={{ mb: 2 }}>
                  <SingleSelector
                    id="camera-details"
                    placeholder="Type to search"
                    label="Select camera"
                    value={camera}
                    onChange={handleCameraSelect}
                    getOptionLabel={(option) => {
                      if (option.remoteDeviceName && option.remoteDeviceLocation) {
                        return `${option.name} at ${option.remoteDeviceName} (${option.remoteDeviceLocation})`;
                      } if (option.remoteDeviceName) {
                        return `${option.name} at ${option.remoteDeviceName}`;
                      }
                      return option.name;

                    }}
                    options={filterAuthorized(cameraList)}
                  />
                  {camera != null
                    && cameraInfo != null
                    && infoFetchStatus !== 'pending' && (
                      <Alert severity="success">{`Camera info found for ${camera.name}`}</Alert>
                    )}
                  {camera != null
                    && cameraNetwork != null
                    && infoFetchStatus !== 'pending'
                    && adaptorType !== 'mms' && (
                      <Alert severity="success">{`Network info found for ${camera.name}`}</Alert>
                    )}
                  {camera != null
                    && cameraInfo == null
                    && networkFetchStatus !== 'pending' && (
                      <Alert severity="error">{`Failed to get camera info for ${camera.name}`}</Alert>
                    )}
                  {camera != null
                    && cameraNetwork == null
                    && networkFetchStatus !== 'pending'
                    && adaptorType !== 'mms' && (
                      <Alert severity="error">{`Failed to get network info for ${camera.name}`}</Alert>
                    )}
                </Stack>
              </Box>
            </Card>
          </Grid>
          <Grid item xs={12} sm={12} md={adaptorType === 'mms' ? 12 : 6}>
            <Card>
              <Box sx={{ p: 3 }}>
                <Stack spacing={3} sx={{ mb: 2 }}>
                  <Divider sx={{ my: 2 }}>
                    <Typography variant="h5" sx={{ color: 'text.secondary' }}>
                      Camera details
                    </Typography>
                  </Divider>
                  {cameraInfoPresent && (
                    <CameraInfo
                      camera={camera}
                      cameraInfo={cameraInfo}
                      key={`${cameraInfo.SensorId}_info`}
                    />
                  )}
                </Stack>
              </Box>
            </Card>
          </Grid>
          {adaptorType !== 'mms' && (
            <Grid item xs={12} sm={12} md={6}>
              <Card>
                <Box sx={{ p: 3 }}>
                  <Stack spacing={3} sx={{ mb: 2 }}>
                    <Divider sx={{ my: 2 }}>
                      <Typography variant="h5" sx={{ color: 'text.secondary' }}>
                        Network details
                      </Typography>
                    </Divider>
                    {networkInfoPresent && (
                      <CameraNetworkInfo
                        camera={camera}
                        networkInfo={cameraNetwork}
                        key={`${cameraNetwork.ipAddressV4 + cameraNetwork.ipAddressV6
                          }`}
                      />
                    )}
                  </Stack>
                </Box>
              </Card>
            </Grid>
          )}
        </Grid>
      </Container>
    </>
  );
}
